import { localization } from "../localizationManager";

export var japaneseStrings = {
  groupButton: "グループ化",
  ungroupButton: "グループ解除",
  selectButton: "選択",
  hideColumn: "列を非表示",
  showColumn: "列を表示",
  makePrivateColumn: "列を非公開にする",
  makePublicColumn: "列を公開する",
  moveToDetail: "詳細に移動",
  showAsColumn: "列として表示",
  filterPlaceholder: "検索...",
  removeRows: "行を削除",
  showLabel: "表示",
  entriesLabel: "件",
  visualizer_text: "テキスト",
  visualizer_wordcloud: "ワードクラウド",
  visualizer_histogram: "ヒストグラム",
  visualizer_number: "平均",
  visualizer_choices: "テーブル",
  visualizer_selectBase: "チャート",
  chartType_bar: "棒グラフ",
  chartType_vbar: "縦棒グラフ",
  chartType_stackedbar: "積み上げ棒グラフ",
  chartType_doughnut: "ドーナツチャート",
  chartType_pie: "円グラフ",
  chartType_scatter: "散布図",
  chartType_gauge: "ゲージ",
  chartType_bullet: "バレット",
  hideButton: "非表示",
  makePrivateButton: "非公開にする",
  makePublicButton: "公開する",
  showButton: "表示",
  filter: "フィルター",
  resetFilter: "フィルターをリセット",
  changeLocale: "言語を変更",
  clearButton: "クリア",
  addElement: "表示する質問を選択...",
  defaultOrder: "デフォルト順",
  ascOrder: "昇順",
  descOrder: "降順",
  showMinorColumns: "マイナー列を表示",
  otherCommentTitle: "その他のアイテムとコメント",
  showPercentages: "パーセンテージを表示",
  hidePercentages: "パーセンテージを非表示",
  pdfDownloadCaption: "PDF",
  xlsxDownloadCaption: "Excel",
  csvDownloadCaption: "CSV",
  saveDiagramAsPNG: "プロットをPNGファイルとして保存",
  hideEmptyAnswers: "空の回答を非表示",
  showEmptyAnswers: "空の回答を表示",
  "topNValueText-1": "すべての回答",
  "topNValueText5": "上位5つの回答",
  "topNValueText10": "上位10の回答",
  "topNValueText20": "上位20の回答",
  hideMissingAnswers: "欠損値を非表示",
  showMissingAnswers: "欠損値を表示",
  missingAnswersLabel: "欠損値",
  noVisualizerForQuestion: "この質問タイプはまだ視覚化されていません",
  noResults: "まだ結果がありません",
  showPerValues: "値ごとに表示",
  showPerColumns: "列ごとに表示",
  answer: "回答",
  correctAnswer: "正解: ",
  percent: "パーセント",
  responses: "回答数"
};

localization.locales["ja"] = japaneseStrings;
localization.localeNames["ja"] = "Japanese";
